import Component from './component'
import WithTranslation from '../../globals/components/withTranslation'

export default WithTranslation(Component)
